import React from 'react';
import { StyledComponentProps, withStyles, Button } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Plus } from '../../images/icons/plus.svg';

interface IProps extends StyledComponentProps {
    onClick: () => any;
    disabled?: boolean;
    text: string;
}
//
const NewItemButton = (props: IProps) => {
    return (<Button
        disabled={props.disabled}
        className={props.classes.btnRoot}
        onClick={props.onClick} 
        variant="contained">
        <div className={props.classes.withIcon}>
            {props.text}
            <Plus className={props.classes.newItemIcon}/>
        </div>
    </Button>)

}


export default withStyles(styles)(NewItemButton)